module.exports = __webpack_public_path__ + "3cbde5c9b76dc26528b9b03885041904.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-420.webp
// module id = 511
// module chunks = 0